<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapnumber"><a id="h4">Chapter 2</a></h2><a id="h4">
</a><h2 class="chaptitle"><a id="h4">The King’s Wood and Lindrick<sup></sup></a><a id="fn2-1"></a><span href="#/188_notes#fne2-1" title="Link target outside of Sample">1</span></h2>
<h3 class="h3"><a id="h5">Roche Abbey</a></h3><a id="h5">
<p class="noindent"><span class="dropcap">R</span>oche Abbey is famous among architectural historians well beyond the borders of South Yorkshire because its ruined transepts that date from the 1170s and 1180s rank with parts of the cathedrals of Canterbury and Wells as the earliest surviving examples of the Gothic style that was introduced into England from France. In 1147 two neighbouring lords, Richard de Busli, lord of Maltby, and Richard, son of Turgis, lord of Hooton Levitt, gave land and woods on the edges of their estates to found a Cistercian monastery. All Cistercian abbeys were dedicated to St Mary, but this one took its distinctive name - St Mary de la Roche - from a huge rock on the north side of the magnesian limestone gorge that was thought to resemble a massive cross-head and which became an object of pilgrimage.</p>
<p class="indent">In time, the name Roche was softened in local speech to ‘Roach’, in the same way that the famous Cistercian abbey at Rievaulx in North Yorkshire became known locally as ‘Rivis’. The original buildings at Roche were wooden ones, but from the 1170s most of them were replaced in local stone that was quarried on the hillside to the north. By the late 1180s the monks were in great debt to Jewish money lenders. To their relief, but to their shame, in the 1190s, at the height of the Crusades and anti-Jewish feeling, King Richard I released them from a debt of 1,300 marks (roughly £866), an enormous sum in those days.</p>
</a><h3 class="h3"><a id="h5"></a><a id="h6">Woods</a></h3><a id="h6">
<p class="noindent">The abbey’s foundation charter included Roger de Busli’s grant of ‘a wood called North Wood’ (the present Nor Wood), which descended to the Maltby Dike, and the allowance of:</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 14_chapter02.vue?69617368